import { render } from "./VideoView.vue?vue&type=template&id=35dcb783&scoped=true&ts=true"
import script from "./VideoView.vue?vue&type=script&lang=ts"
export * from "./VideoView.vue?vue&type=script&lang=ts"

import "./VideoView.vue?vue&type=style&index=0&id=35dcb783&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35dcb783"]])

export default __exports__